import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./header.css";
import "./ResponsiveHeader.css";
import logo from "../../assets/logo.svg";
import { AppDownloadModal } from "../common/AppDownloadModal";

export const Header = () => {
  const [isAppModalOpen, setIsAppModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const handleOpenAppModal = () => {
    setIsMobileMenuOpen(false);
    setIsAppModalOpen(true);
  };

  return (
    <>
      <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
        <div className="wraper">
          <div className="logo" onClick={() => handleNavClick("/")} style={{ cursor: "pointer" }}>
            <img src={logo} alt="ShareRecipe Logo" />
          </div>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul>
              <li>
                <button
                  className="mainBtn"
                  type="button"
                  onClick={() => handleNavClick("/recipes")}
                >
                  Healthy Recipes
                </button>
              </li>
              <li>
                <button
                  className="mainBtn"
                  type="button"
                  style={{ backgroundColor: "#FFBE41", color: "#2A1844", fontWeight: "600" }}
                  onClick={() => handleNavClick("/clubs")}
                >
                  Recipe Clubs
                </button>
              </li>
              <li>
                <button
                  className="secondaryBtn"
                  type="button"
                  onClick={handleOpenAppModal}
                >
                  Get App
                </button>
              </li>
            </ul>
          </nav>

          {/* Mobile Hamburger Icon */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-nav-dropdown">
            <button
              className="mobile-nav-item mainBtn"
              type="button"
              onClick={() => handleNavClick("/recipes")}
            >
              Healthy Recipes
            </button>
            <button
              className="mobile-nav-item mainBtn"
              type="button"
              style={{ backgroundColor: "#FFBE41", color: "#2A1844", fontWeight: "600" }}
              onClick={() => handleNavClick("/clubs")}
            >
              Recipe Clubs
            </button>
            <button
              className="mobile-nav-item secondaryBtn"
              type="button"
              onClick={handleOpenAppModal}
            >
              Get App
            </button>
          </div>
        )}
      </header>

      <AppDownloadModal
        isOpen={isAppModalOpen}
        onClose={() => setIsAppModalOpen(false)}
        title="Download ShareRecipe App"
      />
    </>
  );
};
